import classNames from "classnames";
import type { BlockProps } from "./Block";
import { Block } from "./Block";

export interface MediumRectangleProps extends BlockProps {}

export const MediumRectangle = ({
  className,
  ...rest
}: MediumRectangleProps) => (
  <Block className={classNames("h-3 rounded-[3px]", className)} {...rest} />
);
